import { render, staticRenderFns } from "./Merch.vue?vue&type=template&id=7e2fd50a&scoped=true&"
import script from "./Merch.vue?vue&type=script&lang=js&"
export * from "./Merch.vue?vue&type=script&lang=js&"
import style0 from "./Merch.vue?vue&type=style&index=0&id=7e2fd50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2fd50a",
  null
  
)

export default component.exports